import { useQuery } from '@tanstack/react-query';
import { useAuthState } from '../../+state/useAuthState';
import { AdminAuthService } from '../../services/admin-auth';

export const AUTH_REFRESH_QUERY_KEY = 'auth-refresh';

export const useAuthRefresh = () => {
  const { setUser } = useAuthState();
  return useQuery({
    queryKey: [AUTH_REFRESH_QUERY_KEY],
    queryFn: () => {
      return AdminAuthService.refresh();
    },
    onSuccess: (data) => {
      setUser(data);
    },
    onError: () => {
      setUser(null);
    },
    retry: 0
  });
};